var map = {
	"./de/btn-download.png": "xUkG",
	"./en/btn-download.png": "NijH",
	"./es/btn-download.png": "F1FX",
	"./fr/btn-download.png": "8qsP",
	"./ja/btn-download.png": "8lJi",
	"./ko/btn-download.png": "YsEx",
	"./pt/btn-download.png": "FF5P",
	"./ru/btn-download.png": "sS30",
	"./th/btn-download.png": "u5df",
	"./zh-Hant/btn-download.png": "iOg9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xgti";